<app-log-header
  [activeTab]="activeTab()"
  [companiesList]="companiesList()"
  [selectedCompanyId]="selectedCompanyId()"
  (tabChanged)="switchTab($event)"
  (companyChanged)="selectCompany($event)" />

<app-f-chips />

<div
  class="table-container"
  saveHeight
  [bottomOffset]="48">
  <div class="table">
    <table
      cdk-table
      appTable
      [dataSource]="dataSource()"
      appSort
      [(sort)]="sort">
      @for (col of displayedColumns(); track col) {
        <ng-container [cdkColumnDef]="col">
          <th
            cdk-header-cell
            appSortHeader
            *cdkHeaderCellDef>
            {{ tableHeaderList[col] }}
          </th>
          <td
            cdk-cell
            *cdkCellDef="let row">
            @switch (col) {
              @case ('created_at') {
                {{ row[col] | customDateFormat: 'dd.MM.yyyy, HH:mm:ss' }}
              }
              @default {
                {{ row[col] || '-' }}
              }
            }
          </td>
        </ng-container>
      }

      <tr *cdkNoDataRow>
        <td [attr.colspan]="displayedColumns().length">
          @if (isLoaded()) {
            <app-table-empty
              message="No logs"
              [filtered]="isFiltered()" />
          }
        </td>
      </tr>

      <tr
        cdk-header-row
        *cdkHeaderRowDef="displayedColumns()"></tr>
      <tr
        cdk-row
        *cdkRowDef="let row; columns: displayedColumns()"></tr>
    </table>
  </div>
</div>

<app-paginator
  [length]="length()"
  [pageIndex]="pagination().pageIndex"
  [pageSize]="pagination().pageSize"
  [pageSizeOptions]="[5, 10, 25]"
  (page)="pagination.set($event)" />
